
<h1>Notifications</h1>
<mat-card>
  <mat-card-content>
    <div>
      <div class="mat-elevation-z8">
        <mat-table [dataSource]="notifications" >
          <ng-container matColumnDef="message">
            <mat-header-cell *matHeaderCellDef> Notification </mat-header-cell>
            <mat-cell *matCellDef="let notification" [ngClass]="{'unread-notification': !notification.is_read}">
              {{ notification?.notification?.message! }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="sentAt">
            <mat-header-cell *matHeaderCellDef> Date/Heure </mat-header-cell>
            <mat-cell *matCellDef="let notification" [ngClass]="{'unread-notification': !notification.is_read}">
              {{ notification.sent_at | date: 'dd/MM/yyyy, HH:mm' }}
            </mat-cell>
          </ng-container>
      
          <mat-header-row *matHeaderRowDef="['message', 'sentAt']"></mat-header-row>
          <mat-row *matRowDef="let row; columns: ['message', 'sentAt'];" (click)="onNotificationClick(row)" class="clickable-row"></mat-row>
        </mat-table>
      </div>
    </div>
    <div class="close-button">
      <button mat-raised-button (click)="closeDialog()">Fermer</button>
    </div>
  </mat-card-content>
</mat-card>

